import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRemove = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 21,
	height: 22,
	viewBox: "0 0 21 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 10.5,
			cy: 11.4329,
			r: 10,
			fill: "#131924",
			stroke: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.4257 8.11492C17.0115 7.52913 17.0115 6.57939 16.4257 5.9936C15.8399 5.40781 14.8901 5.40781 14.3043 5.9936L5.06092 15.237C4.47514 15.8228 4.47514 16.7726 5.06092 17.3583C5.64671 17.9441 6.59646 17.9441 7.18224 17.3583L16.4257 8.11492Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.18175 5.99358C6.59597 5.4078 5.64622 5.4078 5.06043 5.99358C4.47465 6.57937 4.47465 7.52912 5.06043 8.1149L14.072 17.1265C14.6578 17.7123 15.6076 17.7123 16.1934 17.1265C16.7792 16.5407 16.7792 15.591 16.1934 15.0052L7.18175 5.99358Z",
			fill: "white"
		})
	]
});
export default SvgRemove;
